import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { inject, observer } from 'mobx-react'
import { Button, Confirm, Icon } from 'semantic-ui-react'
import Divider from '@ui/Divider'

@inject('surveyState', 'appState')
@observer
class StepContainer extends Component {
  confirmPerfectScoring = () => this.props.surveyState.acceptPerfectScoring()

  render() {
    const {
      t,
      surveyState,
      onBack,
      onSkip,
      onNext,
      onNextEnabled,
      children,
      appState
    } = this.props
    const { right_to_left } = appState.getLanguageByCode(surveyState.language_code)
    const textDirection = appState.getTextDirection(surveyState.language_code)

    const back = onBack && (
      <Button
        animated
        onClick={onBack}
        size='big'
        className='survey-button inverted'
      >
        <Button.Content visible>{t('Previous')}</Button.Content>
        <Button.Content hidden>
          <Icon name={`arrow ${right_to_left ? 'right' : 'left'}`} fitted />
        </Button.Content>
      </Button>
    )

    const skip = onSkip && (
      <Button
        animated
        onClick={onSkip}
        size='big'
        className='survey-button inverted'
      >
        <Button.Content visible>{t('Skip')}</Button.Content>
        <Button.Content hidden>
          <Icon name={`arrow ${right_to_left ? 'left' : 'right'}`} fitted />
        </Button.Content>
      </Button>
    )

    const next = (
      <Button
        animated
        onClick={onNext}
        size='big'
        disabled={!onNextEnabled}
        className='survey-button primary'
      >
        <Button.Content visible>{t(surveyState.continueButton)}</Button.Content>
        <Button.Content hidden>
          <Icon name={`arrow ${right_to_left ? 'left' : 'right'}`} fitted />
        </Button.Content>
      </Button>
    )

    const actions = (
      <div className='custom-actions'>
        <Divider section soft />
        <div className='button-actions flex no-wrap'>
          {back || <div />}
          {skip}
          {next}
        </div>
      </div>
    )

    return (
      <div className='custom-container flex vertical'>
        {children}
        {actions}
        <Confirm
          dir={textDirection}
          className='survey-confirm'
          open={surveyState.showPerfectScoreWarning}
          onConfirm={this.confirmPerfectScoring}
          header={t('Please be thoughtful with your responses.')}
          confirmButton={t('Okay')}
          cancelButton={null}
          closeOnDimmerClick={false}
          content={t(
            'Answering a survey with all "5 - Best" responses is often viewed as a negative by hiring managers.'
          )}
          size='tiny'
        />
      </div>
    )
  }
}

export default withTranslation()(StepContainer)
